import QrCode2Icon from "@mui/icons-material/QrCode2";
import { Button } from "@mui/material";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import AttendanceQrCode from "./AttendanceQrCode";

const AttendanceQrCodeDialog = ({ classId, onStop }) => {
  return (
    <ConfirmModal
      titleContent="Отбелязване на присъствие с QR код"
      isConfirmButton={false}
      closeTitle="Спри отбелязването"
      dialogProps={{ fullScreen: true }}
      resetProps={onStop}
      // A MUI button, not the react-admin one: below the sm breakpoint react-admin collapses
      // its button to an icon-only IconButton, which would hide the label on phones
      triggerButton={
        <Button
          color="success"
          variant="contained"
          size="small"
          startIcon={<QrCode2Icon />}
        >
          Отбелязване с QR код
        </Button>
      }
    >
      <AttendanceQrCode classId={classId} />
    </ConfirmModal>
  );
};

export default AttendanceQrCodeDialog;
